import React from "react";

interface ZipPickerProps {
  zip: string;
  onChange: (zip: string) => void;
  className?: string;
  size?: "sm" | "md";
}

export default function ZipPicker({
  zip,
  onChange,
  className = "",
  size = "md",
}: ZipPickerProps) {
  const padding = size === "sm" ? "py-2" : "py-2.5";

  function handleChange(value: string) {
    const digitsOnly = value.replace(/\D/g, "").slice(0, 5);
    onChange(digitsOnly);
    if (digitsOnly.length === 5) localStorage.setItem("mouna_zip", digitsOnly);
    else if (digitsOnly.length === 0) localStorage.removeItem("mouna_zip");
  }

  return (
    <div className={`flex gap-2 ${className}`}>
      <div className="flex-1 relative">
        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
          📍
        </span>
        <input
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          maxLength={5}
          value={zip}
          onChange={(e) => handleChange(e.target.value)}
          placeholder="ZIP code"
          className={`w-full pl-9 pr-3 ${padding} rounded-xl border border-gray-300 focus:border-mouna-blue focus:outline-none text-sm`}
        />
      </div>
      {zip && (
        <button
          onClick={() => handleChange("")}
          className="px-3 text-xs text-gray-500 hover:text-gray-700"
        >
          Clear
        </button>
      )}
    </div>
  );
}

// Helper to read the persisted ZIP from anywhere
export function getStoredZip(): string {
  try {
    return localStorage.getItem("mouna_zip") || "";
  } catch {
    return "";
  }
}
